import React from 'react';

// type Props = {
//   to: string;
//   name: string;
//   activeColor?: string;
//   children?: any;
//   style?: any;
//   target?: any;
//   onClick?: any;
// };

/* eslint-disable no-unused-vars */
const WebLink = ({ to, name, children, activeColor, ...rest }: any) => (
  <a href={to} {...rest}>
    {children || name}
  </a>
);

export default WebLink;
